import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

interface ErrorInfo {
  code: string;
  title: string;
  description: string;
  icon: string;
}

@Component({
  selector: 'app-error',
  imports: [RouterModule, TranslatePipe, CommonModule],
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit {
  errorNumber = '404';
  errorInfo!: ErrorInfo;

  private readonly errorIcons: { [key: string]: string } = {
    '400': 'pi pi-exclamation-triangle',
    '401': 'pi pi-lock',
    '403': 'pi pi-ban',
    '404': 'pi pi-search',
    '500': 'pi pi-server',
    '503': 'pi pi-wrench'
  };

  activatedRoute = inject(ActivatedRoute);
  router = inject(Router);
  translateService = inject(TranslateService);

  constructor() {}

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(data => {
      this.errorNumber = data['errorNumber'] || '404';
      this.loadErrorInfo();
    });

    // Re-load error info when language changes
    this.translateService.onLangChange.subscribe(() => {
      this.loadErrorInfo();
    });
  }

  private loadErrorInfo(): void {
    const errorKey = `ERRORS.${this.errorNumber}`;
    
    this.translateService.get([`${errorKey}.TITLE`, `${errorKey}.DESCRIPTION`]).subscribe(translations => {
      this.errorInfo = {
        code: this.errorNumber,
        title: translations[`${errorKey}.TITLE`] || 'Error',
        description: translations[`${errorKey}.DESCRIPTION`] || 'An error occurred.',
        icon: this.errorIcons[this.errorNumber] || 'pi pi-exclamation-circle'
      };
    });
  }

  goHome(): void {
    this.router.navigate(['/dashboard']);
  }

  goBack(): void {
    window.history.back();
  }

  logout(): void {
    localStorage.clear();
    this.router.navigate(['/']);
  }
}
